import { ChangeEventHandler, FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import {
  RecipientOption,
  recipientOptions,
} from '../constants/recipientOptions';

type RecipientEmail = {
  name: string;
  email: string;
};

type SendEmailRecipientsMenuProps = {
  recipients: Record<string, RecipientEmail[]>;
  onSetRecipients: ChangeEventHandler<HTMLInputElement>;
};

const SendEmailRecipientsMenu: FC<SendEmailRecipientsMenuProps> = ({
  recipients,
  onSetRecipients,
}) => {
  const { t } = useTranslate();

  const isOptionDisabled = (option: RecipientOption): boolean => {
    if (!option.recipientKey) return false;
    return !recipients[option.recipientKey]?.length;
  };

  const getOptionLabel = (option: RecipientOption): string =>
    option.labelKeys.map((key) => t(key)).join(' ');

  return (
    <div className="card p-4">
      <div className="card-aside-wrap">
        <div className="card-content">
          <div className="card-inner p-0">
            <h6 className="title mb-3">{t('Recipient(s)')}</h6>
            <ul className="custom-control-group d-flex flex-row justify-content-between">
              {recipientOptions.map((option: RecipientOption) => (
                <li key={option.id}>
                  <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                    <input
                      type="radio"
                      className="custom-control-input"
                      name="btnRadio"
                      id={option.id}
                      value={option.value}
                      disabled={isOptionDisabled(option)}
                      onChange={onSetRecipients}
                    />
                    <label className="custom-control-label" htmlFor={option.id}>
                      {getOptionLabel(option)}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendEmailRecipientsMenu;
